import React, { memo, useMemo } from 'react';
import { View, Image, TouchableOpacity } from 'react-native';
import { Text, IconArrowLeft } from '@redlink/components/atoms';
import { MoreButton } from '@redlink/components/molecules';
import { createUseStyle } from '@redlink/assets/styles';
import { useValues } from '@redlink/assets/values';
import { useQuery, getPageProfileQuery } from '@redlink/services';
import { useLocale } from '@redlink/assets/locale';

export const Ads = memo(({ onShowPlans }) => {
  const { styles, colors } = useStyle();
  const { staticData } = useValues();
  const { dictionary } = useLocale();

  const adsMock = useMemo(
    () => [
      {
        text: dictionary.adsItem1,
        image: require('@redlink/assets/images/landing_icon_crown.png'),
        backgroundColor: '#866dff',
        actionText: dictionary.adsItem1Action,
        url: '',
        type: 'plan',
      },
      {
        text: dictionary.adsItem2,
        image: require('@redlink/assets/images/instagram.png'),
        backgroundColor: '#4c1184',
        actionText: dictionary.adsItem2Action,
        url: 'https://instagram.com/redl.ink',
        type: 'external',
      },
      {
        text: dictionary.adsItem3,
        image: require('@redlink/assets/images/logo_white.png'),
        backgroundColor: '#f4354c',
        actionText: dictionary.adsItem3Action,
        url: 'https://virgool.io/redlink',
        type: 'external',
      },
      {
        text: dictionary.adsItem4,
        image: require('@redlink/assets/images/instagram.png'),
        backgroundColor: '#11066f',
        actionText: dictionary.adsItem4Action,
        url: 'https://instagram.com/redl.ink',
        type: 'external',
      },
    ],
    [dictionary]
  );

  const { text, image, backgroundColor, actionText, url, type, isBusy } =
    useRandomAdItem(adsMock);

  return isBusy ? null : (
    <TouchableOpacity
      style={[styles.container, { ...{ backgroundColor } }]}
      activeOpacity={0.7}
      onPress={() =>
        type === staticData.adType.plan
          ? onShowPlans()
          : window.open(url, '_blank')
      }
    >
      <View style={styles.leftContainer}>
        <Image source={image} style={styles.image} />
        <Text style={styles.text} numberOfLines={1} ellipsizeMode="tail">
          {text}
        </Text>
      </View>
      <MoreButton title={actionText} textStyle={styles.moreButtonText} disabled arrowColor={colors.blue12} />
    </TouchableOpacity>
  );
});

const useRandomAdItem = (data) => {
  const { staticData } = useValues();

  const {
    data: {
      PageProfile: { currentPlan: { accountType, isProUser } = {} } = {},
    },
  } = useQuery(getPageProfileQuery);

  return useMemo(() => {
    const ads = isProUser
      ? data.filter(({ type }) => type !== staticData.adType.plan)
      : data;

    return {
      ...ads[Math.floor(Math.random() * ads.length)],
      isBusy: !accountType,
    };
  }, [accountType]);
};

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    margin: 6,
    padding: 12,
    maxHeight: size.adsBoxHeight,
    borderRadius: 10,
    overflow: 'hidden',
    alignItems: 'center',
    flexDirection: 'row',
  },
  leftContainer: {
    flex: 1,
    flexDirection: 'row',
    marginEnd: 5,
  },
  image: {
    width: 24,
    height: 24,
    resizeMode: 'contain',
    marginEnd: 10,
  },
  text: {
    fontSize: 12,
    lineHeight: 24,
    fontWeight: '500',
    color: 'white',
  },
  moreButtonText: {
    color: colors.blue12
  }
}));
